module.exports = __webpack_public_path__ + "static/dj-snake-14e3fc55d85bccf51666b6a843fe1a14.png";